import useIsFeatureEnabled from "PFCore/helpers/use_is_feature_enabled";
import { useIsCurrentUserPermittedTo } from "PFCore/helpers/use_is_permitted_to";
import { FeatureFlag, PermissionRule } from "PFTypes";

export const useIsProPilotPermitted = (): boolean => {
  const isProPilotEnabled = useIsFeatureEnabled(FeatureFlag.ProPilot);
  const isPermitted = useIsCurrentUserPermittedTo(PermissionRule.ProPilot);
  return isProPilotEnabled && isPermitted;
};
